/* --- QUESTIONNAIRE CONFIG --- */

export interface QuestionnaireTSQM {
  position: number;
  question: string;
  answers: string[];
}

export const Q_TSQM: QuestionnaireTSQM[] = [
  {
    position: 1, question: 'Quanto è soddisfatto/a o insoddisfatto/a della capacità del farmaco di prevenire o trattare il suo problema?',
    answers: [
      'Estremamente insoddisfatto/a',
      'Molto insoddisfatto/a',
      'Insoddisfatto/a',
      'Abbastanza Soddisfatto/a',
      'Soddisfatto/a',
      'Molto soddisfatto/a',
      'Estremamente soddisfatto/a'
    ]
  },
  {
    position: 2, question: 'Quanto è soddisfatto/a o insoddisfatto/a del modo in cui il farmaco allevia i suoi sintomi?',
    answers: [
      'Estremamente insoddisfatto/a',
      'Molto insoddisfatto/a',
      'Insoddisfatto/a',
      'Abbastanza Soddisfatto/a',
      'Soddisfatto/a',
      'Molto soddisfatto/a',
      'Estremamente soddisfatto/a'
    ]
  },
  {
    position: 3, question: 'Quanto è soddisfatto/a o insoddisfatto/a della quantità di tempo che il farmaco impiega ad agire?',
    answers: [
      'Estremamente insoddisfatto/a',
      'Molto insoddisfatto/a',
      'Insoddisfatto/a',
      'Abbastanza soddisfatto/a',
      'Soddisfatto/a',
      'Molto soddisfatto/a',
      'Estremamente soddisfatto/a'
    ]
  },
  {
    position: 4, question: 'Questo farmaco le causa effetti collaterali di qualche genere?',
    answers: [
      'Si',
      'No (in questo caso, passi alla domanda n.9)'
    ]
  },
  {
    position: 5, question: 'Quanto sono fastidiosi gli effetti collaterali del farmaco che assume per trattare il suo problema?',
    answers: [
      'Estremamente fastidiosi',
      'Molto fastidiosi',
      'Abbastanza fastidiosi',
      'Un po\' fastidiosi',
      'Per niente fastidiosi'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 6, question: 'In che misura gli effetti collaterali interferiscono con la sua salute fisica e la capacità di svolgere le sue attività quotidiane (es. forza fisica, livello di energia, ecc.)?',
    answers: [
      'Moltissimo',
      'Molto',
      'Abbastanza',
      'Poco',
      'Per niente'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 7, question: 'In che misura gli effetti collaterali interferiscono con le sue funzioni mentali (es. la capacità di pensare lucidamente, di restare sveglio/a ecc.)?',
    answers: [
      'Moltissimo',
      'Molto',
      'Abbastanza',
      'Poco',
      'Per niente'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 8, question: 'In che misura gli effetti collaterali del farmaco influiscono sul suo grado di soddisfazione generale per il farmaco?',
    answers: [
      'Moltissimo',
      'Molto',
      'Abbastanza',
      'Poco',
      'Per niente'
    ]
  },
  {
    position: 9, question: 'Quanto facile o difficile è l\'impiego del farmaco nella sua forma attuale?',
    answers: [
      'Estremamente difficile',
      'Molto difficile',
      'Difficile',
      'Abbastanza facile',
      'Facile',
      'Molto facile',
      'Estremamente facile'
    ]
  },
  {
    position: 10, question: 'Quanto facile o difficile è pianificare quando usare il farmaco ogni volta?',
    answers: [
      'Estremamente difficile',
      'Molto difficile',
      'Difficile',
      'Abbastanza facile',
      'Facile',
      'Molto facile',
      'Estremamente facile'
    ]
  },
  {
    position: 11, question: 'Quanto è comodo o scomodo assumere il farmaco come da istruzioni?',
    answers: [
      'Estremamente scomodo',
      'Molto scomodo',
      'Scomodo',
      'Abbastanza comodo',
      'Comodo',
      'Molto comodo',
      'Estremamente comodo'
    ]
  },
  {
    position: 12, question: 'Complessivamente, quanto è sicuro/a che il farmaco le sia di giovamento?',
    answers: [
      'Per niente sicuro/a',
      'Poco sicuro/a',
      'Abbastanza sicuro/a',
      'Molto sicuro/a',
      'Estremamente sicuro/a',
    ]
  },
  {
    position: 13, question: 'Quanto è sicuro/a che i vantaggi offerti dal farmaco superino gli svantaggi?',
    answers: [
      'Per niente sicuro/a',
      'Poco sicuro/a',
      'Abbastanza sicuro/a',
      'Molto sicuro/a',
      'Estremamente sicuro/a',
    ]
  },
  {
    position: 14, question: 'Complessivamente, quanto è soddisfatto/a o insoddisfatto/a del farmaco?',
    answers: [
      'Estremamente insoddisfatto/a',
      'Molto insoddisfatto/a',
      'Insoddisfatto/a',
      'Abbastanza Soddisfatto/a',
      'Soddisfatto/a',
      'Molto soddisfatto/a',
      'Estremamente soddisfatto/a'
    ]
  },
];

/* ------------ RESULTS CONFIGURATION + CONSTRUCTOR ------------ */

export class TSQMResults {
  patientSSN: string;
  doctorID: string;
  results: string[];

  constructor(doctorID: string, patientSSN: string, results: string[]) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
  }

}
